import { blue1, blue2, blue3, blue4, blue5, blue6, blue7, blue8, blue9, blue10, purple1, purple2, purple3, purple4, purple5, purple6, purple7, purple8, purple9, purple10, cyan1, cyan2, cyan3, cyan4, cyan5, cyan6, cyan7, cyan8, cyan9, cyan10, green1, green2, green3, green4, green5, green6, green7, green8, green9, green10, magenta1, magenta2, magenta3, magenta4, magenta5, magenta6, magenta7, magenta8, magenta9, magenta10, red1, red2, red3, red4, red5, red6, red7, red8, red9, red10, orange1, orange2, orange3, orange4, orange5, orange6, orange7, orange8, orange9, orange10, yellow1, yellow2, yellow3, yellow4, yellow5, yellow6, yellow7, yellow8, yellow9, yellow10, volcano1, volcano2, volcano3, volcano4, volcano5, volcano6, volcano7, volcano8, volcano9, volcano10, geekblue1, geekblue2, geekblue3, geekblue4, geekblue5, geekblue6, geekblue7, geekblue8, geekblue9, geekblue10, lime1, lime2, lime3, lime4, lime5, lime6, lime7, lime8, lime9, lime10, gold1, gold2, gold3, gold4, gold5, gold6, gold7, gold8, gold9, gold10, colorTextBase, colorTextLightSolid, colorBgBase, fontFamily, fontSize, lineWidth, borderRadius, sizeUnit, sizePopupArrow, controlHeight, opacityImage, sizeStep, sizeXXL, sizeXL, sizeLG, sizeMD, sizeMS, size, sizeSM, sizeXS, sizeXXS, controlHeightSM, controlHeightXS, controlHeightLG, lineWidthFocus, borderRadiusXS, borderRadiusSM, borderRadiusLG, borderRadiusOuter, colorText, colorTextSecondary, colorTextTertiary, colorTextQuaternary, colorFill, colorFillSecondary, colorFillTertiary, colorFillQuaternary, colorBgSpotlight, colorBorder, colorBorderSecondary, colorSplit, colorBgContainer, colorBgLayout, colorBgElevated, colorPrimaryBg, colorPrimaryBgHover, colorPrimaryBorder, colorPrimaryBorderHover, colorPrimaryHover, colorPrimaryActive, colorPrimaryTextHover, colorPrimaryText, colorPrimaryTextActive, colorSuccessBg, colorSuccessBgHover, colorSuccessBorder, colorSuccessBorderHover, colorSuccessHover, colorSuccessActive, colorSuccessTextHover, colorSuccessText, colorSuccessTextActive, colorWarningBg, colorWarningBgHover, colorWarningBorder, colorWarningBorderHover, colorWarningHover, colorWarningActive, colorWarningTextHover, colorWarningText, colorWarningTextActive, colorErrorBg, colorErrorBgHover, colorErrorBorder, colorErrorBorderHover, colorErrorHover, colorErrorActive, colorErrorTextHover, colorErrorText, colorErrorTextActive, colorInfoBg, colorInfoBgHover, colorInfoBorder, colorInfoBorderHover, colorInfoHover, colorInfoActive, colorInfoTextHover, colorInfoText, colorInfoTextActive, colorPrimary, colorError, colorWarning, colorSuccess, colorInfo, colorBgMask, colorFillContent, colorFillContentHover, colorFillAlter, colorBgContainerDisabled, colorBorderBg, colorTextPlaceholder, colorTextDisabled, colorTextHeading, colorTextLabel, colorTextDescription, colorBgTextHover, colorBgTextActive, colorIcon, colorIconHover, colorLink, colorLinkHover, colorLinkActive, colorHighlight, controlOutline, colorWarningOutline, colorErrorOutline, fontSizeSM, fontSizeLG, fontSizeXL, fontSizeIcon, fontSizeHeading1, fontSizeHeading2, fontSizeHeading3, fontSizeHeading4, fontSizeHeading5, fontWeightStrong, controlOutlineWidth, controlItemBgHover, controlItemBgActive, controlItemBgActiveHover, controlInteractiveSize, controlItemBgActiveDisabled, controlTmpOutline, opacityLoading, padding, paddingMD, paddingSM, paddingXS, paddingXXS, paddingLG, paddingXL, margin, marginSM, marginXS, marginXXS, marginLG, marginXL, controlPaddingHorizontal, controlPaddingHorizontalSM, paddingContentHorizontalLG, paddingContentVerticalLG, paddingContentHorizontal, paddingContentVertical, paddingContentHorizontalSM, paddingContentVerticalSM, boxShadow, boxShadowSecondary } from "./../variables";
export const defaultTheme = {
    components: {
        Progress: {
            colorSuccess: colorPrimary
        }
    },
    token: {
        blue1,
        blue2,
        blue3,
        blue4,
        blue5,
        blue6,
        blue7,
        blue8,
        blue9,
        blue10,
        purple1,
        purple2,
        purple3,
        purple4,
        purple5,
        purple6,
        purple7,
        purple8,
        purple9,
        purple10,
        cyan1,
        cyan2,
        cyan3,
        cyan4,
        cyan5,
        cyan6,
        cyan7,
        cyan8,
        cyan9,
        cyan10,
        green1,
        green2,
        green3,
        green4,
        green5,
        green6,
        green7,
        green8,
        green9,
        green10,
        magenta1,
        magenta2,
        magenta3,
        magenta4,
        magenta5,
        magenta6,
        magenta7,
        magenta8,
        magenta9,
        magenta10,
        red1,
        red2,
        red3,
        red4,
        red5,
        red6,
        red7,
        red8,
        red9,
        red10,
        orange1,
        orange2,
        orange3,
        orange4,
        orange5,
        orange6,
        orange7,
        orange8,
        orange9,
        orange10,
        yellow1,
        yellow2,
        yellow3,
        yellow4,
        yellow5,
        yellow6,
        yellow7,
        yellow8,
        yellow9,
        yellow10,
        volcano1,
        volcano2,
        volcano3,
        volcano4,
        volcano5,
        volcano6,
        volcano7,
        volcano8,
        volcano9,
        volcano10,
        geekblue1,
        geekblue2,
        geekblue3,
        geekblue4,
        geekblue5,
        geekblue6,
        geekblue7,
        geekblue8,
        geekblue9,
        geekblue10,
        lime1,
        lime2,
        lime3,
        lime4,
        lime5,
        lime6,
        lime7,
        lime8,
        lime9,
        lime10,
        gold1,
        gold2,
        gold3,
        gold4,
        gold5,
        gold6,
        gold7,
        gold8,
        gold9,
        gold10,
        colorTextBase,
        colorTextLightSolid,
        colorBgBase,
        fontFamily,
        fontSize,
        lineWidth,
        borderRadius,
        sizeUnit,
        sizePopupArrow,
        controlHeight,
        opacityImage,
        sizeStep,
        sizeXXL,
        sizeXL,
        sizeLG,
        sizeMD,
        sizeMS,
        size,
        sizeSM,
        sizeXS,
        sizeXXS,
        controlHeightSM,
        controlHeightXS,
        controlHeightLG,
        borderRadiusXS,
        borderRadiusSM,
        borderRadiusLG,
        borderRadiusOuter,
        colorText,
        colorTextSecondary,
        colorTextTertiary,
        colorTextQuaternary,
        colorFill,
        colorFillSecondary,
        colorFillTertiary,
        colorFillQuaternary,
        colorBgSpotlight,
        colorBorder,
        colorBorderSecondary,
        colorSplit,
        colorBgContainer,
        colorBgLayout,
        colorBgElevated,
        colorPrimaryBg,
        colorPrimaryBgHover,
        colorPrimaryBorder,
        colorPrimaryBorderHover,
        colorPrimaryHover,
        colorPrimaryActive,
        colorPrimaryTextHover,
        colorPrimaryText,
        colorPrimaryTextActive,
        colorSuccessBg,
        colorSuccessBgHover,
        colorSuccessBorder,
        colorSuccessBorderHover,
        colorSuccessHover,
        colorSuccessActive,
        colorSuccessTextHover,
        colorSuccessText,
        colorSuccessTextActive,
        colorWarningBg,
        colorWarningBgHover,
        colorWarningBorder,
        colorWarningBorderHover,
        colorWarningHover,
        colorWarningActive,
        colorWarningTextHover,
        colorWarningText,
        colorWarningTextActive,
        colorErrorBg,
        colorErrorBgHover,
        colorErrorBorder,
        colorErrorBorderHover,
        colorErrorHover,
        colorErrorActive,
        colorErrorTextHover,
        colorErrorText,
        colorErrorTextActive,
        colorInfoBg,
        colorInfoBgHover,
        colorInfoBorder,
        colorInfoBorderHover,
        colorInfoHover,
        colorInfoActive,
        colorInfoTextHover,
        colorInfoText,
        colorInfoTextActive,
        colorPrimary,
        colorError,
        colorWarning,
        colorSuccess,
        colorInfo,
        colorBgMask,
        colorFillContent,
        colorFillContentHover,
        colorFillAlter,
        colorBgContainerDisabled,
        colorBorderBg,
        colorTextPlaceholder,
        colorTextDisabled,
        colorTextHeading,
        colorTextLabel,
        colorTextDescription,
        colorBgTextHover,
        colorBgTextActive,
        colorIcon,
        colorIconHover,
        colorLink,
        colorLinkHover,
        colorLinkActive,
        colorHighlight,
        controlOutline,
        colorWarningOutline,
        colorErrorOutline,
        fontSizeSM,
        fontSizeLG,
        fontSizeXL,
        fontSizeIcon,
        fontSizeHeading1,
        fontSizeHeading2,
        fontSizeHeading3,
        fontSizeHeading4,
        fontSizeHeading5,
        fontWeightStrong,
        controlOutlineWidth,
        controlItemBgHover,
        controlItemBgActive,
        controlItemBgActiveHover,
        controlInteractiveSize,
        controlItemBgActiveDisabled,
        controlTmpOutline,
        lineWidthFocus,
        opacityLoading,
        padding,
        paddingMD,
        paddingSM,
        paddingXS,
        paddingXXS,
        paddingLG,
        paddingXL,
        margin,
        marginSM,
        marginXS,
        marginXXS,
        marginLG,
        marginXL,
        controlPaddingHorizontal,
        controlPaddingHorizontalSM,
        paddingContentHorizontalLG,
        paddingContentVerticalLG,
        paddingContentHorizontal,
        paddingContentVertical,
        paddingContentHorizontalSM,
        paddingContentVerticalSM,
        boxShadow,
        boxShadowSecondary
    }
};
